import type { SurveyQuestion } from '../../../dtos/survey.dto'

export type FormValues = Record<string, string | number | undefined>

export interface SurveyResponseFormProps {
  questions: SurveyQuestion[]
  values: FormValues
  errors: Partial<Record<keyof FormValues, string | string[]>>
  touched: Partial<Record<keyof FormValues, boolean>>
  onChange: (questionId: string, value: string | number | undefined) => void
  onBlur?: (questionId: string) => void
  disabled?: boolean
  title?: string
  description?: string
  defaultPlaceholderText?: string
}
